module.exports = __webpack_public_path__ + "img/quizIcon.798ffd7d.png";